import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=45b53c41&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b53c41",
  null
  
)

export default component.exports